module.exports = __webpack_public_path__ + "static/media/Precipitation.f0f5af62.png";